//mypreset.ts
import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';
export const fmcTheme = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#E3EFF8',
      100: '#BCD8EE',
      200: '#94C1E4',
      300: '#6DA9DA',
      400: '#4692D0',
      500: '#074E82',
      600: '#063E69',
      700: '#052F51',
      800: '#041F38',
      900: '#020F1F',
      950: '#01070F',
    },

    formField: {
      sm: {
        fontSize: '0.875rem',
        paddingX: '0.5rem',
        paddingY: '0.325rem',
      },
      paddingX: '0.625rem',
      paddingY: '0.5rem',
      lg: {
        fontSize: '1.125rem',
        paddingX: '0.75rem',
        paddingY: '0.625rem',
      },
    },
    overlay: {
      modal: {
        padding: '1.0rem',
      },
    },
  },

  primitive: {
    borderRadius: {
      none: '0',
      xs: '1px',
      sm: '2px',
      md: '3px',
      lg: '6px',
      xl: '8px',
    },
  },
  components: {
    button: {
      root: {
        iconOnlyWidth: '2.625rem',
        sm: {
          iconOnlyWidth: '2.125rem',
        },
      },
    },
    datatable: {
      bodyCell: {
        sm: {
          padding: '0.3rem .5rem',
        },
        padding: '0.5rem 0.75rem',
      },

      headerCell: {
        sm: {
          padding: '0.3rem .5rem',
        },
        padding: '0.5rem 0.75rem',
        selectedBackground: '#ffffff',
        selectedColor: '{text.color}',
      },
    },
    inputtext: {
      root: {
        sm: {
          paddingY: '0.2rem',
        },
        paddingY: '.325rem',

        lg: {
          paddingY: '0.4rem',
        },
      },
    },
    tabs: {
      root: { transitionDuration: '{transition.duration}' },
      tablist: {
        borderWidth: '0',
        background: 'transparent',
        borderColor: '{content.border.color}',
      },
      tab: {
        borderWidth: '1px 1px 0 1px',
        borderColor: '{surface.300}',
        hoverBorderColor: '{surface.400}',
        activeBorderColor: 'transparent',
        color: '{text.color}',
        hoverColor: '{text.hoverColor}',
        activeColor: '{surface.0}',
        margin: '0 .15rem 0 0',
        padding: '0rem 0.75rem',
        fontWeight: 'normal',
        // border radius is handled in the styles.scss
      },
      colorScheme: {
        light: {
          navButton: {
            shadow: '0px 0px 10px 50px rgba(254, 0, 0, 0.6)',
          },
          tab: {
            background: '{surface.200}',
            hoverBackground: '{surface.300}',
            activeBackground: '{primary.500}',
          },
        },
      },
    },
    togglebutton: {
      root: {
        sm: {
          padding: '0.325rem 0.75rem',
        },
        padding: '0.5rem 0.75rem',
        lg: {
          padding: '0.625rem 1rem',
        },
      },
    },
  },
});

// REJECT ME IF YOU SEE ME
// Uncomment this to see what should be overwritten to make a global overwrite
// console.log(JSON.stringify(fmcTheme));
// console.log(fmcTheme);
